






































import { Component, Vue, Watch } from 'vue-property-decorator';

import UserCard from '@/components/UserCard.vue';
import ListCard from '@/components/list-cards/ListCard.vue';
import MediumListCard from '@/components/list-cards/MediumListCard.vue';

import { ListModelUtil } from '@/model-utils/list-model-util';
import { UserProfileUtil } from '@/model-utils/user-profile-util';

import { ListModel } from '@/models/list-model';
import { UserProfile } from '@/models/user-profile';

import { UserModule } from '@/store/modules/user';

@Component({
  components: {
    ListCard,
    MediumListCard,
    UserCard
  }
})
export default class Home extends Vue {
  recentLists: ListModel[] = [];
  topLists: ListModel[] = [];
  usersToFollow: UserProfile[] = [];

  allDone: boolean = false;

  created() {
    const p1 = ListModelUtil.getHighlightedLists(100).then(
      lists =>
        (this.topLists = lists
          .filter(l => l.authorId != UserModule.currentUserId)
          .slice(0, 10))
    );
    const p2 = ListModelUtil.getMostRecentLists(100).then(
      lists =>
        (this.recentLists = lists
          .filter((l) => l.numItems > 1)
          .filter((l) => l.images.length > 0)
          .filter(l => l.authorId != UserModule.currentUserId)
          .slice(0, 10))
    );
    const p3 = UserProfileUtil.fetchMostFollowedProfiles().then(users => {
      this.usersToFollow = users.filter(
        u =>
          u.id != UserModule.currentUserId &&
          UserModule.followedUserIds.indexOf(u.id) == -1
      );
    });
    Promise.all([p1, p2, p3]).then(() => (this.allDone = true));
  }

  get isLoggedIn(): boolean {
    return UserModule.isLoggedIn;
  }
}
